/**
 * Konto dialogs
 */

(function ( $ ) {
	$.dialogYesNo = function (options) {
		var settings = $.extend({}, $.dialogYesNo.defaults, options);
		var dlg = $("<div title=\"" + settings.title + "\">" + settings.content + "</div>");
		var buttons = {};
		buttons[settings.yesCaption] = function () {
			settings.onYes();
			if (settings.autoClose) {
				$(this).dialog("close");
				$(this).dialog("destroy");
			}
		};
		buttons[settings.noCaption] = function () {
			settings.onNo();
			if (settings.autoClose) {
				$(this).dialog("close");
				$(this).dialog("destroy");
			}
		};
		dlg.dialog({
			autoOpen: true,
			modal: true,
			buttons: buttons,
			width: "auto"
		});
		$('.ui-dialog :button').blur();
	};
	
	$.dialogYesNo.defaults = {
		title: "Upozorenje",
		content: "Niste zadali sadržaj dialoga",
		onYes: function () { },
		onNo: function () { },
		yesCaption: "Da",
		noCaption: "Ne",
		autoClose: true,
		autoDestroy: true
	};
	
	function makeOnButtonClickCallback(value, dialog) {
		if (value.click) {
			return function () {
				value.click();
				if (value.autoClose !== false) {
					dialog.close();
				}
			};
		}
		else {
			return function () {
				if (value.autoClose !== false) {
					dialog.close();
				}
			};
		}
	}
	
	/**
	 * Params
	 * @buttons - buttoni
	 * @dialog - referenca na kendoWindow da bismo mogli zatvoriti prozor nakon onclick
	 * 	eventa na button
	 */
	function getButtons(buttons, dialog) {
		var html = "";
		var functions = [];
		for (var i = 0; i < buttons.length; ++i) {
			var button = buttons[i];
			var guid = KUtils.generateGUID();
			var callback = null;
			var additionalClasses = "";
			if (typeof button === "object") {
				callback = makeOnButtonClickCallback(button, dialog);
				if (button.isDefault !== false)
					additionalClasses = " btn-light";
				if (button.isPrimary === true) 
					additionalClasses = " btn-primary";
			}
			functions.push({guid: guid, callback: callback});
			
			html += "<button type=\"button\" class=\"btn" + additionalClasses + "\"" + 
				" id=\"" + guid + "\">" + button.caption + "</button>";
		}
		return {
			html: html,
			functions: functions
		};
	}
	
	/**
	 * Button:
	 * 	- click: function () {}
	 *  - isDefault (default: true)
	 *  - isPrimary (default: false)
	 *  - autoClose (default: true)
	 */
	$.dialog = function (options) {
		if (typeof options === "string")
			options = {content: options};
		var settings = $.extend({}, $.dialogGreska.defaults, options);
		var _window = $("<div>");
		$("body").append(_window);
		var dialog = _window.kendoKontoModal(settings).data("kendoKontoModal");
		
		if (settings.autoOpen) {
			dialog.open();
		}
		return dialog;
	};
	
	$.dialogGreska = function (options) {
		if ($.isEmptyObject(options.buttons)) {
			options.buttons = {
				"U redu": {
					isPrimary: true
				}
			};
			options.focusPrimaryButton = true;
		}
		$.dialog(options);
	};
	
	function getOnCloseFunction(onClose) {
		var func = function () { onClose(); };
		return func;
	}
	
	$.dialogGreska.defaults = {
		title: "Obavijest",
    	bgHeaderColorClass: "bg-danger text-white",		
		content: "Niste zadali sadržaj",
		noButtons: false,
		onClose: function () { },
		autoOpen: true,
		autoDestroy: true,
		modal: true
	};
	
	$.dialogInfo = function (options) {
		$.dialogGreska(options);
	};
	
	$.dialogUpozori = function (options) {
		if (typeof options === "string")
			options = {content: options};
		options = $.extend({title: "Upozorenje"}, options);
		$.dialogGreska(options);
	};
	
	$.dialogHelp = function (options) {
		if (typeof options === "string") 
			options = {content: options};
		options = $.extend({title: "Pomoć", width: 650}, options);
		$.dialogGreska(options);
	};
	
	$.dialogPdf = function (options) {
		var settings = $.extend({}, $.dialogPdf.defaults, options);
		if (settings.objectId == "")
			settings.objectId = "pdf-" + KUtils.generateGUID();
		var myPDF = new PDFObject({
			url: settings.url + (settings.local ? "" : "?viewBrowser"),
			id: settings.objectId,
			width: settings.width,
			height: settings.height
		});
		
		var dialog = $("<div>");
		
		var button = $("<button>");
		if (!settings.noDownload) {
			var divPrikaz = $("<div>");
			divPrikaz.append("U slučaju problema s prikazom ");
			divPrikaz.append(button);
			button.html("preuzmite ovdje");
			button.click(function (e) {
				KFileUtils.downloadIzvjestaj(settings.url);	
			});
			dialog.append(divPrikaz);
		}
		
		var pdfDiv = $("<div class='pdf-object'>");
		dialog.append(pdfDiv);
		
		dialog.kendoKontoModal({
			//modal: true,
			autoOpen: true,
			title: "PDF prikaz",
			//width: 1000,
			//height: 750,
			buttons: settings.buttons
		});
		
		var res = myPDF.embed(pdfDiv[0]);
		return res;
	};
	
	$.dialogPdf.defaults = {
		title: "Pregled PDF-a",
		url: "",
		objectId: "",
		width: "100%",
		height: "100%",
		local: false,
		noDownload: false,
		buttons: {}
	};
	
	$.dialogSession = function (loginPath) {
		var msg = "Sesija je istekla. Trebate se ponovno prijaviti.";
		if (loginPath) {
			msg += "<br /><a href=\"" + loginPath + "\">Natrag na prijavu</a>";
		}
		$.dialogGreska({
			autoOpen: true,
			title: "Istek sesije",
			content: msg
		});
	};
	
	/**
	 * Prima HTML koji predstavlja template.
	 */
	$.dialogIspis = function (html, dialogId, dialogOpts) {
		$("#" + dialogId).dialog(opts);
	};
	
	konto.dialogs = {};

	/**
	 * Dohvaća šifarnik. 
	 * 
	 * Parametar options:
	 *     potrebno je zadati putanju do templatea
	 * 
	 * Povratna vrijednost:
	 *     modalni prozor
	 */
	konto.dialogs.sifarnik = function (options) {
	    var settings = $.extend(true, {}, konto.dialogs.sifarnik.defaults, options);
	    var userShown = settings.shown;
        settings.shown = function () {
            // Očekujem da će u većini slučajeva ovdje biti grid.
            var mainGrid = this.element.find(".main-grid");
            if (mainGrid.length > 0) {
                var kontoGrid = $(mainGrid[0]).data("kendoKontoGrid");
                if (typeof kontoGrid !== "undefined"){
                    kontoGrid.grid.table.focus();
                }	
            }
             
            if (userShown) {
                userShown.call(this);
            }
        };
	    
	    var _wndSifarnik = $("<div></div>");
        $("body").append(_wndSifarnik);
        _wndSifarnik.kendoKontoModal(settings);
        
        var wndSifarnik = _wndSifarnik.data("kendoKontoModal");
        wndSifarnik.element.find("div.modal-dialog").on("onOdabir", function (event, data) {
            settings.odabir(data);
            wndSifarnik.close();
        });
        return wndSifarnik;    
	};
	
	konto.dialogs.sifarnik.defaults = {
        autoOpen: true,
        autoDestroy: true,
		isSifarnik: true,		
        data: {
            sifarnik: 1
        },
        width: "85%",
        odabir: function (data) { }
    };
    
    /**
     * Dohvaća modalni dialog.
     */
    konto.dialogs.modal = function (options) {
        var settings = $.extend(true, {}, konto.dialogs.modal.defaults, options);
        var _wnd = $("<div></div>");
        $("body").append(_wnd);
        
        _wnd.kendoKontoModal(settings);	
		_wnd.find('.modal-header').before("<div class='modal-overlay'></div>");
		var modalOverlay = $(".modal-overlay");
		if(modalOverlay.length > 1){
			for(i=0; i<(modalOverlay.length-2); i++){
				$(modalOverlay[i]).removeClass("modal-overlay-on");
			}
			$(modalOverlay[modalOverlay.length-2]).addClass("modal-overlay-on");	
		}

		_wnd.on("hidden.bs.modal", function(e){
			var modalOverlay = $(".modal-overlay");
			if(modalOverlay.length > 1){
				$(modalOverlay[modalOverlay.length-2]).removeClass("modal-overlay-on");
			}
			if(modalOverlay.length > 2){
				$(modalOverlay[modalOverlay.length-3]).addClass("modal-overlay-on");
			}			
		});		
        
        var wnd = _wnd.data("kendoKontoModal");

		//if(modalOverlay.length > 2){
		//	debugger;
		//	$(".modal-backdrop").addClass("hide");
		//}
        return wnd;
    };
    
    konto.dialogs.modal.defaults = {
        autoOpen: true,
        autoDestroy: true  
    };
    
    konto.dialogs.login = function (options) {
        var settings = $.extend(true, {}, konto.dialogs.login.defaults, options);
        var _wnd = $("<div/>");
        $("body").append(_wnd);
        
        if (!settings.template)
            settings.template = kontorouter.getModulPath("login");
        
        _wnd.kendoKontoModal(settings);  
    };
    
    konto.dialogs.login.defaults = {
        title: "Prijava u program",
        autoOpen: true,
        autoDestroy: true,
        width: "85%"
    };
    
    konto.dialogs.upozori = function (options) {
    	var settings = $.extend(true, 
    			{}, 
    			konto.dialogs.modal.defaults, 
    			konto.dialogs.upozori.defaults,
    			options);
    	return konto.dialogs.modal(settings);	
    };
    
    konto.dialogs.upozori.defaults = {
    	title: "Upozorenje",
		bgHeaderColorClass: "bg-warning text-white",    	
    	ok: function () { },    	
    	buttons: {
    		"U redu": {
    			click: function () {
					this.options.ok();
					this.close();	
					if(this.options.afterClose != "undefined"){
						this.options.afterClose();
					}										
    			},
    			isPrimary: true
    		}
    	}
    };
    
    konto.dialogs.obavijest = function (options) {
    	var settings = $.extend(true, 
    			{}, 
    			konto.dialogs.modal.defaults, 
    			konto.dialogs.obavijest.defaults,
    			options);
    	var dialOb = konto.dialogs.modal(settings);
		if((options.autoCloseInSeconds) && (options.autoCloseInSeconds != 0)){
			var autoCloseInMiliSeconds = options.autoCloseInSeconds * 1000;
            setTimeout(function()
            {   
            	dialOb.close()                                                                                                                                                                                                               
            }, autoCloseInMiliSeconds); 				
		}	
		return dialOb;		
    };
    
    konto.dialogs.obavijest.defaults = {
    	title: "Obavijest",
    	bgHeaderColorClass: "bg-info text-white",
    	buttons: {
    		"U redu": {
    			click: function () {
    				this.close();
					if(this.options.afterClose != "undefined"){
						this.options.afterClose();
					}					
    			},
    			isPrimary: true
    		}
    	}
    };    
    
    konto.dialogs.greska = function (options) {
    	var settings = $.extend(true, 
    			{}, 
    			konto.dialogs.modal.defaults, 
    			konto.dialogs.greska.defaults,
    			options);
    	return konto.dialogs.modal(settings);	
    };
    
    konto.dialogs.greska.defaults = {
    	title: "Greška",
    	bgHeaderColorClass: "bg-danger text-white",
    	buttons: {
    		"U redu": {
    			click: function () {
    				this.close();
					if(this.options.afterClose != "undefined"){
						this.options.afterClose();
					}
    			},
    			isPrimary: true
    		}
    	}
    };
    
    konto.dialogs.opasnost = function (options) {
    	var settings = $.extend(true, 
    			{}, 
    			konto.dialogs.modal.defaults, 
    			konto.dialogs.opasnost.defaults,
    			options);
    	return konto.dialogs.modal(settings);	
	};	
    
    konto.dialogs.opasnost.defaults = {
    	title: "Upozorenje",
    	bgHeaderColorClass: "bg-danger text-white"
    };
        
    konto.dialogs.pretraga = function (options) {
    	var settings = $.extend(true, 
    			{}, 
    			konto.dialogs.modal.defaults, 
    			konto.dialogs.pretraga.defaults,
    			options);
    	return konto.dialogs.modal(settings);	
    };
    
    konto.dialogs.pretraga.defaults = {
    	title: "Ispis",
    	bgHeaderColorClass: "bg-light"
    };     
    
    konto.dialogs.upit = function (options) {
   		var settings = $.extend(true, 
   			{},
   			konto.dialogs.modal.defaults,
   			konto.dialogs.upit.defaults,
   			options);
   			
   		// Ako su buttonsi zadani, ne diram ih
   		if (typeof options.buttons === "undefined") {
   			settings.buttons = {
   				"Da": {
   					isPrimary: true,
   					click: function () {
   						if (settings.potvrdi.call(this) !== false){
   							this.close();	
							if(this.options.afterClose != "undefined"){
								this.options.afterClose();
							}						
						}
   					}
   				},
   				"Ne": {
   					click: function () {
   						if (settings.odustani.call(this) !== false){
							this.close();
							if(this.options.afterClose != "undefined"){
								this.options.afterClose();
							}	
						}					
   					}
   				}
   			};
   		}
		return konto.dialogs.modal(settings); 
    };
    
    konto.dialogs.upit.defaults = {
    	title: "Obavijest",
    	bgHeaderColorClass: "bg-primary text-white",    	
    	potvrdi: function () {  },
    	odustani: function () {  }
    };
    
    konto.dialogs.upitspozadinom = function (options) {
   		var settings = $.extend(true, 
   			{},
   			konto.dialogs.modal.defaults,
   			konto.dialogs.upitspozadinom.defaults,
   			options);
   			
   		// Ako su buttonsi zadani, ne diram ih
   		if (typeof options.buttons === "undefined") {
   			settings.buttons = {
   				"Da": {
   					isPrimary: true,
   					click: function () {
   						if (settings.potvrdi.call(this) !== false){
							this.close();
							if(this.options.afterClose != "undefined"){
								this.options.afterClose();
							}	
						}	
   					}
   				},
   				"Da u pozadini": {
   					isPrimary: true,
   					click: function () {
   						if (settings.potvrdiupozadini.call(this) !== false){
						   this.close();
						   if(this.options.afterClose != "undefined"){
							   this.options.afterClose();
						   }	
					   }	
   					}
   				},   				
   				"Ne": {
   					click: function () {
   						if (settings.odustani.call(this) !== false){							
							this.close();
							if(this.options.afterClose != "undefined"){
								this.options.afterClose();
							}	
						}	
   					}
   				}
   			};
   		}
		return konto.dialogs.modal(settings); 
    };
    
    konto.dialogs.upitspozadinom.defaults = {
    	title: "Obavijest",
    	bgHeaderColorClass: "bg-primary text-white",    	
    	potvrdi: function () {  },
    	potvrdiupozadini: function () {  },
    	odustani: function () {  }
    };
        
    konto.dialogs.alert = function (options) {
    	var settings = $.extend({}, konto.dialogs.alert.defaults, options);
    	
    	var alertDiv = $("<div />", {
    		class: "alert alert-info " + (settings.dismissible ? "alert-dismissible " : "") + settings.type,
    		role: "alert"
    	});
    	
    	if (settings.dismissible === true)
	    	$("<button>", {
	    		type: "button",
	    		class: "close",
	    		"data-dismiss": "alert",
	    		"aria-label": "Close"
	    	}).appendTo(alertDiv).append($("<span />", {
	    		"aria-hidden": "true",
	    		"text": "×"
	    	}));
    	
    	if (typeof settings.title === "string" && settings.title.length > 0) 
    		$("<h4 />").html(settings.title).appendTo(alertDiv);
    		
    	$("<p />").appendTo(alertDiv).append(settings.content);
    	
    	alertDiv.appendTo(settings.root).alert();
    	return alertDiv;	
    };
    
    konto.dialogs.alert.defaults = {
		type: "alert-danger",
		dismissible: true,
		content: "Not a thing!"
    };
    
    konto.dialogs.pitanja = function(pitanja){
        var dfd = $.Deferred();        
        var i = 0;
        $.each(pitanja.FPitanja, function(key, val) {
            konto.dialogs.upit({
                content: val.FUpit,
                potvrdi: function () { setOdgovorNaPitanje(val, ++i, true, pitanja, dfd); },
                odustani: function () { setOdgovorNaPitanje(val, ++i, false, pitanja, dfd); }
            }); 
        });
        
        return dfd.promise();
    };
    
    konto.dialogs.obradiValidatorRes = function(valRes){
        if (valRes.FReturnType == "rtSuccess"){
            var war = valRes.Warnings;
            if (war.length > 0){ 
                for (i = 0; i < war.length - 1; i++){
                    if (war[i].WarningMsg != "" ){
                        konto.dialogs.upozori({ content: war[i].WarningMsg });    
                    }
                }   
            }else if (valRes.FWarningMsg != "" ){
                konto.dialogs.upozori({ content: valRes.FWarningMsg });    
            }
            //zadnja je jer je stack
            if (valRes.FSuccessMsg != ''){
                konto.dialogs.obavijest({ content: valRes.FSuccessMsg });
            }
        }else if (valRes.FReturnType == "rtError"){
            konto.dialogs.greska({ content: valRes.FErrorMsg });
        }          
    };
    
    function setOdgovorNaPitanje(pitanje, i, odgovor, pitanja, dfd){
        pitanje.FIsSetOdgovor = true;
        pitanje.FOdgovor = odgovor; 
        if (i == pitanja.FPitanja.length){
            dfd.resolve(pitanja);    
        } 
    }
    
}( jQuery, window.konto = window.konto || {} ));